/**
 * Shared button styles for held call components
 * Centralized to maintain consistency and reduce duplication
 */

export const baseClasses = `
  w-full flex items-center justify-between
  cursor-pointer transition-all duration-200
  outline-none
`;

export const itemClasses = `
  h-[55px]
  px-[16px] py-[8px]
  focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-inset
`;

export const itemHoverStateClasses = `
  hover:bg-[#F2F2F2] focus-visible:bg-[#F2F2F2]
`;
